export const SCREEN_ADDRESS = 'SCREEN_ADDRESS'
export const SCREEN_BASIC_INFO = 'SCREEN_BASIC_INFO'
export const SCREEN_API_SEARCH_DATA = 'SCREEN_API_SEARCH_DATA'
export const SCREEN_COSTS = 'SCREEN_COSTS'
export const SCREEN_DESCRIPTION = 'SCREEN_DESCRIPTION'
export const SCREEN_MULTIMEDIA = 'SCREEN_MULTIMEDIA'
export const SCREEN_CONTACT_INFO = 'SCREEN_CONTACT_INFO'
export const SCREEN_OTHER_FACILITIES = 'SCREEN_OTHER_FACILITIES'
export const SCREEN_CONNECTIONS = 'SCREEN_CONNECTIONS'
export const SCREEN_CONSTRUCTION = 'SCREEN_CONSTRUCTION'
export const SCREEN_TENANT_DOCUMENTS = 'SCREEN_TENANT_DOCUMENTS'
export const SCREEN_FLAT_SHARE_ROOM_PROPERTIES = 'SCREEN_FLAT_SHARE_ROOM_PROPERTIES'
export const SCREEN_REALTOR_LEAD_ENGINE = 'SCREEN_REALTOR_LEAD_ENGINE'
export const SCREEN_WHO_WE_LOOK_FOR = 'SCREEN_WHO_WE_LOOK_FOR'
export const SCREEN_OBJECT_NUMBERS = 'SCREEN_OBJECT_NUMBER'
export const SCREEN_OBJECT_DETAILS = 'SCREEN_OBJECT_DETAILS'
export const SCREEN_ADDTIONAL_INFORMATION_CTA = 'SCREEN_OBJECT_DETAILS_CTA'
export const SCREEN_WEB_VIEW_AMENITIES = 'SCREEN_WEB_VIEW_AMENITIES'
export type ScreenName =
  | 'address'
  | 'basicInfo'
  | 'costs'
  | 'description'
  | 'contactInfo'
  | 'multimedia'
  | 'attachments'
  | 'otherFacilities'
  | 'connections'
  | 'construction'
  | 'tenantDocuments'
  | 'flatShareRoomProperties'
  | 'whoWeLookFor'
  | 'apiSearchData'
  | 'realtorLeadEngine'
  | 'objectNumbers'
  | 'objectDetails'
  | 'objectDetailsCta'
  | 'webViewAmenities'

export type ScreenEntry = {
  id: string
  name: ScreenName
  trackingName: string
  translation: string
  defaultTranslation: string
}

export const SCREENS: Record<string, ScreenEntry> = {
  [SCREEN_ADDRESS]: {
    id: 'address-screen',
    name: 'address',
    trackingName: 'address',
    translation: 'wizard.navigation.label.address',
    defaultTranslation: 'Address',
  },
  [SCREEN_BASIC_INFO]: {
    id: 'basic-info-screen',
    name: 'basicInfo',
    trackingName: 'basic_info',
    translation: 'wizard.navigation.label.basicInfo',
    defaultTranslation: 'Basic info',
  },
  [SCREEN_COSTS]: {
    id: 'costs-screen',
    name: 'costs',
    trackingName: 'price_info',
    translation: 'wizard.navigation.label.costs',
    defaultTranslation: 'Costs',
  },
  [SCREEN_DESCRIPTION]: {
    id: 'description-screen',
    name: 'description',
    trackingName: 'description',
    translation: 'wizard.navigation.label.description',
    defaultTranslation: 'Description',
  },
  [SCREEN_CONTACT_INFO]: {
    id: 'contact-info-screen',
    name: 'contactInfo',
    trackingName: 'contact_info',
    translation: 'wizard.navigation.label.contactInfo',
    defaultTranslation: 'Contact Info',
  },
  [SCREEN_MULTIMEDIA]: {
    id: 'multimedia-screen',
    name: 'multimedia',
    trackingName: 'attachments',
    translation: 'wizard.navigation.label.multimedia',
    defaultTranslation: 'Multimedia',
  },
  [SCREEN_OTHER_FACILITIES]: {
    id: 'other-facilities-screen',
    name: 'otherFacilities',
    trackingName: 'other_facilities',
    translation: 'wizard.navigation.label.otherFacilities',
    defaultTranslation: 'Other Facilities',
  },
  [SCREEN_CONNECTIONS]: {
    id: 'connections-screen',
    name: 'connections',
    trackingName: 'connections',
    translation: 'wizard.navigation.label.connections',
    defaultTranslation: 'Connections',
  },
  [SCREEN_CONSTRUCTION]: {
    id: 'construction-screen',
    name: 'construction',
    trackingName: 'construction',
    translation: 'wizard.navigation.label.construction',
    defaultTranslation: 'Construction',
  },
  [SCREEN_TENANT_DOCUMENTS]: {
    id: 'tenant-documents-screen',
    name: 'tenantDocuments',
    trackingName: 'tenantDocuments',
    translation: 'wizard.navigation.label.tenantDocuments',
    defaultTranslation: 'TenantDocuments',
  },
  [SCREEN_FLAT_SHARE_ROOM_PROPERTIES]: {
    id: 'flat-share-room-properties-screen',
    name: 'flatShareRoomProperties',
    trackingName: 'flatShareRoomProperties',
    translation: 'wizard.navigation.label.flatShareRoomProperties',
    defaultTranslation: 'FlatShareRoomProperties',
  },
  [SCREEN_WHO_WE_LOOK_FOR]: {
    id: 'who-we-look-for-screen',
    name: 'whoWeLookFor',
    trackingName: 'whoWeLookFor',
    translation: 'wizard.navigation.label.whoWeLookFor',
    defaultTranslation: 'WhoWeLookFor',
  },
  [SCREEN_API_SEARCH_DATA]: {
    id: 'api-search-data-screen',
    name: 'apiSearchData',
    trackingName: 'apiSearchData',
    translation: 'wizard.navigation.label.apiSearchData',
    defaultTranslation: 'API Search Data',
  },
  [SCREEN_REALTOR_LEAD_ENGINE]: {
    id: 'realtor-lead-engine-screen',
    name: 'realtorLeadEngine',
    trackingName: 'realtorLeadEngine',
    translation: 'wizard.navigation.label.realtorLeadEngine',
    defaultTranslation: 'Sales support',
  },
  [SCREEN_OBJECT_NUMBERS]: {
    id: 'object-number-screen',
    name: 'objectNumbers',
    trackingName: 'objectNumber',
    translation: 'wizard.navigation.label.objectNumber',
    defaultTranslation: 'Object number',
  },
  [SCREEN_OBJECT_DETAILS]: {
    id: 'object-details-screen',
    name: 'objectDetails',
    trackingName: 'objectDetails',
    translation: 'wizard.navigation.label.objectDetails',
    defaultTranslation: 'Object Details',
  },
  [SCREEN_ADDTIONAL_INFORMATION_CTA]: {
    id: 'object-details-cta-screen',
    name: 'objectDetailsCta',
    trackingName: 'objectDetailsCta',
    translation: 'wizard.navigation.label.objectDetailsCta',
    defaultTranslation: 'Additional Details',
  },
  [SCREEN_WEB_VIEW_AMENITIES]: {
    id: 'web-view-amenities-screen',
    name: 'webViewAmenities',
    trackingName: 'web_view_amenities',
    translation: 'wizard.navigation.label.webViewAmenities',
    defaultTranslation: 'Austattung & Sonstiges',
  },
}
